(function() {
  function initTestimonialSlider(section) {
    const carousel = section.querySelector('.collection-list-wrapper');
    if (!carousel || carousel.classList.contains('swiper-initialized')) return;

    // CSS-based activation (optional - always enabled for now)
    const computedContent = window.getComputedStyle(carousel, '::after').getPropertyValue('content');
    
    // Init Swiper
    const swiperInstance = new Swiper(carousel, {
      spaceBetween: 20,
      slidesPerView: 3.9,
      loop: true,
      breakpoints: {
        300: {
            slidesPerView: 2.9
        },
        525: {
            slidesPerView: 2.9
        },
        699: {
            slidesPerView: 3.9 // full slides on larger devices
        },
        999: {
            slidesPerView: 3.9 // full slides on larger devices
        },
        }
    });

    carousel.swiperInstance = swiperInstance;
  }

  function destroyTestimonialSlider(section) {
    const carousel = section.querySelector('.collection-list-wrapper');
    if (carousel?.swiperInstance) {
      carousel.swiperInstance.destroy(true, true);
      carousel.swiperInstance = null;
    }
  }

  function setupTestimonialSlider() {
    document.querySelectorAll('.bd-mobile-collection-list-section').forEach(section => {
      const carousel = section.querySelector('.collection-list-wrapper');
      if (!carousel) return;

      const isEnabled = carousel.classList.contains('swiper-initialized');

      if (!isEnabled) {
        initTestimonialSlider(section);
      }
    });
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupTestimonialSlider);
  } else {
    setupTestimonialSlider();
  }

  // Resize handler (debounced)
  var resizeRunning = false;

  window.addEventListener('resize', () => {
    if (resizeRunning) return;
    resizeRunning = true;

    requestAnimationFrame(() => {
      setupTestimonialSlider();
      resizeRunning = false;
    });
  });

  // Shopify Events
  document.addEventListener('shopify:section:load', e => {
    const section = document.querySelector(`.bd-mobile-collection-list-section[data-section-id="${e.detail.sectionId}"]`);
    if (section) {
      const waitForDOM = () => {
        // Only init when section is actually painted and visible
        if (document.body.contains(section)) {
          requestAnimationFrame(() => setupTestimonialSlider(section));
        } else {
          requestAnimationFrame(waitForDOM);
        }
      };
      requestAnimationFrame(waitForDOM);
    }
    // if (section) setTimeout(setupTestimonialSlider, 500);
  });

  document.addEventListener('shopify:section:unload', e => {
    const section = document.querySelector(`.bd-mobile-collection-list-section[data-section-id="${e.detail.sectionId}"]`);
    if (section) destroyTestimonialSlider(section);
  });

  document.addEventListener('shopify:theme-settings:updated', setupTestimonialSlider);
})();